import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

const MAX_TRANSIENT_RETRIES = 3;

/**
 * Retry only failures that can go away on their own (network errors, 5xx). The
 * shared base query also retries 4xx GETs; a 404 or 403 (e.g. "not set up in
 * skyEmployee", or a product check) is an answer, and must not wait ~14 s of
 * backoff.
 */
export function retryTransientOnly(
  error: FetchBaseQueryError,
  _args: unknown,
  { attempt }: { attempt: number },
): boolean {
  const status = error.status;
  const transient =
    status === "FETCH_ERROR" ||
    status === "TIMEOUT_ERROR" ||
    (typeof status === "number" && status >= 500);
  return transient && attempt <= MAX_TRANSIENT_RETRIES;
}

/**
 * As retryTransientOnly, but once. For a call a whole screen waits on (who is
 * signed in to skyEmployee decides where the app opens): three backed-off
 * retries would hold everyone on a loader for ~14 s during an outage.
 */
export function retryTransientOnce(
  error: FetchBaseQueryError,
  args: unknown,
  { attempt }: { attempt: number },
): boolean {
  return attempt <= 1 && retryTransientOnly(error, args, { attempt });
}
